// extracted by mini-css-extract-plugin
export var leftAlign = "_28-2";
export var popper = "_28-0";
export var subtitle = "_28-1";